import moment from 'moment';

import templateUrl from './rogers-trend-report.component.html';

export const RogersTrendReportComponent = {
    controller: RogersTrendReportController,
    controllerAs: "vm",
    templateUrl,
};

function RogersTrendReportController($q, apexApiUrl, divisionService, rogersDashboardService, utilityService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.endDate;
    vm.enableOnlyWeekday = enableOnlyWeekday;
    vm.onCalendarOpen = onCalendarOpen;
    vm.onExportTrendReport = onExportTrendReport;
    vm.onRefresh = onRefresh;
    vm.reportMode;
    vm.startDate;
    vm.reportType = {
        Text: "Daily",
        value: "Daily"
    };
    vm.trendReport;

    $.setSunday = enableOnlyWeekday(0);
    $.setMonday = enableOnlyWeekday(1);

    function onInit() {

        vm.endWeekDate = getUpcomingDayOfWeek(0);
        vm.startWeekDate = moment(vm.endWeekDate).add(-10, "weeks").toDate();

        vm.startDateOptions = { start: 'month', depth: 'day', disableDates: enableOnlyWeekday(1) };
        vm.endDateOptions = { start: 'month', depth: 'day', disableDates: enableOnlyWeekday(0) };
    }

    function onExportTrendReport() {
        const query = {
            DivisionID: divisionService.divisionIDs.Rogers,
            StartWeekDate: kendo.format("{0:yyyy-MM-dd}", vm.startWeekDate),
            EndWeekDate: kendo.format("{0:yyyy-MM-dd}", vm.endWeekDate),
        };

        const queryString = utilityService.queryStringify(query);
        const api = "dashboards/rogers/rogers-trend-report.xlsx";
        window.location = apexApiUrl + api + queryString;
    }

    function onRefresh() {
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(reloadData(), "Changing dates failed"));
    }


    function reloadData() {

        if (!vm.startWeekDate || !vm.endWeekDate || vm.startWeekDate > vm.endWeekDate) {
            return $q.when();
        }
        return loadRogersTrendReport();
    }

    /**
     * Get the next date that falls on the given day of the week.
     * @param {Number} weekDay The day of the week, as an index starting with Sunday = 0.
     * @returns {Date} The next date that falls of the given day of the week.
     */
    function getUpcomingDayOfWeek(weekDay) {
        const currentWeekDay = new Date().getDay();
        return moment().add(weekDay < currentWeekDay ? weekDay - currentWeekDay + 7 : currentWeekDay - weekDay, "days")
            .startOf("day")
            .toDate();
    }

    function loadRogersTrendReport() {
        const query = {
            DivisionID: divisionService.divisionIDs.Rogers,
            StartWeekDate: vm.startWeekDate,
            EndWeekDate: vm.endWeekDate,
        };
        const retriveData = rogersDashboardService.retrieveRogersTrendReports(query)
        return retriveData
            .then(function (report) {
                vm.trendReport = report;
                return report;
            });
    }

    /**
     * Return a function that filters dates and only returns true if the day
     * of the week is the same as the given day of the week.
     * @param {Number} dayOfWeek
     * @returns {(date : Date) => boolean} A filter function for dates.
     */
    function enableOnlyWeekday(dayOfWeek) {
        return function (date) {
            return date.getDay() === dayOfWeek;
        };
    }


    // Workaround since the version of kendo we are using does not support disabledDates

    function setDates() {
        $(".disabledDay").parent().removeClass("k-link");//removing this class makes the day unselectable
        $(".disabledDay").parent().removeAttr("href"); //this removes the hyperlink styling
    }

    function onCalendarOpen(dp) {
        setDates();
        if (dp.sender.dateView && dp.sender.dateView.calendar) {
            const cal = dp.sender.dateView.calendar;

            if (!cal.additionalNav) {
                //var navigate = cal.navigate;
                cal.bind('navigate', function () {
                    setDates();
                });
                cal.additionalNav = true;
            }
        }

    }
}
